import React from 'react';
import { Link } from 'react-router-dom';
import { PopupLink } from './PopupLink';
const TOUR_URL = 'https://laylo.com/lennoncripe/m/kwIGjg';
const SHOP_URL = 'https://constantperil.square.site';
export function SiteNavLinks() {
  return <nav className="flex flex-col items-start text-left" data-id="element-175" data-mp="3dk7kqi1gmo3l">
      <Link to="/music" className="lowercase hover:opacity-60" data-id="element-176" data-mp="3ijae3582v5vq">
        catalog
      </Link>
      <PopupLink href={TOUR_URL} label="tour" windowName="lennon-cripe-tour" ariaLabel="Open tour dates and RSVP" data-id="element-177" data-mp="2lt02tslvh0dh" />
      <PopupLink href={SHOP_URL} label="shop" windowName="lennon-cripe-shop" ariaLabel="Open the shop" data-id="element-178" data-mp="2pud8o2oyt3ke" />
      <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-179" data-mp="2zssp9bqd8ufn">
        guestbook
      </Link>
    </nav>;
}